export enum SpatialShapeType {
  BLOCK_GROUP = 'BLOCK_GROUP',
  CBSA = 'CBSA',
  CENSUS_TRACT = 'CENSUS_TRACT',
  COUNTY = 'COUNTY',
  STATE = 'STATE'
}
